import { WorkoutStatus } from '@strength/domain';
import { DisplayWorkoutStatus } from '../../components/badge/workout-status-badge';

export const getWorkoutStatusForAthleteWorkout = (
  status: WorkoutStatus,
): DisplayWorkoutStatus => {
  switch (status) {
    case 'completed':
      return { type: 'completed', completed: 1, toComplete: 1 };
    case 'canceled':
    case 'skipped':
      return { type: status };
    default:
      return { type: 'planned' };
  }
};
